import Page from "webPage/Page";
import Track from "util/Track";
import VideoModal from "modal/VideoModal";
import {handleTestimonialSlider} from "util/Testimonials";

Page.register("page-template-homepage", () => {

    $('body').on('click', '.js-play-video', function () {
        let id = $(this).attr('data-video-id');
        let provider = parseInt($(this).attr('data-provider'));
        let modal = new VideoModal(id, provider);
        modal.show();

        return false;
    }).on('click', '.js-faq-item', function () {
        $(this).parent('.faq-item').toggleClass('faq-item--active');
        $(this).closest('.faq-item').find('.faq-item__content').stop().slideToggle(300);
    });


    handleNewsTrack();
    handleTestimonialSlider();
});


export function handleNewsTrack() {
    let $newsTrack = $(".js-news-track-wrap");

    if ($newsTrack.length > 0) {
        let track = new Track($newsTrack, {
            classes: {
                block: "news-track",
            },
        });

        checkWindowWidth();
        $(window).on('resize', checkWindowWidth);

        function checkWindowWidth() {
            if ($(window).width() >= 760) {
                track.enabled = false;
            } else {
                track.enabled = true;
            }
        }
    }
}
